<template>
    <section class="gradient-custom">
        <div class="container my-5 py-5">
            <img v-bind:src="require('@/assets/logo_dark.png')" alt="Responsive image" style="width: 200px;">
            <h2 v-if="serve == 'https://dev.napoleon-chat.com/api/'" style="color: white;">Despliegue en Dev</h2>
            <h2 v-if="serve == 'https://staging.napoleon-chat.com/api/'" style="color: white;">Despliegue en QA</h2>
            <div class="row d-flex justify-content-center py-5">
                <div class="col-md-7 col-lg-7 col-xl-8">
                    <div class="card" style="border-radius: 15px;">
                        <div class="card-body">
                            <h5 class="card-title" siez="17" aria-label="Default"
                                aria-describedby="inputGroup-sizing-default">Consultar Apodo</h5>
                            <span class="border-bottom"></span>
                            <h6 align="left" class="card-title" siez="17" aria-label="Default"
                                aria-describedby="inputGroup-sizing-default">Apodo</h6>
                            <input type="text" id="typeName" class="form-control form-control-lg" siez="17"
                                aria-label="Default" aria-describedby="inputGroup-sizing-default" v-model="query"
                                @keydown="checkForSpaces">
                            <br>
                            <p align="left">*Solo aplica para usuarios Android y iOS ver <a
                                    href="https://napoleon.chat/terminos-condiciones" style="color:#d7a952;"
                                    target="_blank">términos y condiciones</a></p>
                            <a href="https://napoleon.chat/" type="button"
                                class="btn btn-outline-dark">Atrás</a>&nbsp;&nbsp;
                            <button type="button" class="btn btn-outline-warning" :disabled="isInputEmpty"
                                v-on:click="consultInfoUser">Buscar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
 
import HttpsUtils from '@/Utlis/HttpsUtils';
import varConst from '@/globals/VarGlobals'

export default {
    name: 'SearchComponent',
    data() {
        return {
            query: '',
            posts: [],
            user: '',
            idUser: 0,
            serve: ''
        }
    },
    watch: {
        query: function () {
            if (this.query.length >= 3) {
                this.getUsers()
            } else {
                this.posts = []
            }
        }
    },
    computed: {
        isInputEmpty(){
            return !this.query;
        }
    },
    mounted() {
        this.validateId()
    },
    methods: {
        async getUsers() {
            let data = await new HttpsUtils().get('v2/public/user/web/list/payment/' + this.query.toLowerCase())
            if (data != null) {
                this.user = data.data[0].user_nick_name
                this.idUser = data.data[0].user_id
            }
        },

        async consultInfoUser() {
            let data = await new HttpsUtils().get('v3/payment/external/' + this.idUser)
            this.selectOperation(data.data)
        },
        
        selectOperation(data) {
            if (this.idUser != 0) {
                if (!data.status) {
                    this.$router.push({ name: 'unsubscribed', params: { id: this.idUser } })
                } else {
                    this.$router.push({ name: 'active', params: { id: this.idUser } })
                }
            }
        },
        
        validateId() {
            this.serve = varConst.serverSrc
            if (this.esNumero(this.$route.params.id)) {
                this.idUser = this.$route.params.id
                this.consultInfoUser();
            }
        },

        esNumero(valor) {
            return !isNaN(valor);
        },

        checkForSpaces(event) {
            if (event.key === ' ' || event.code === 'Space') {
                event.preventDefault();
            }
        },
    },
}
</script>